import React from 'react';
import { Button } from 'semantic-ui-react';
import { REGISTRATION_URL } from '../lib/constants';

export const Register = ({ isExpanded, onToggle }) => (
  <div id='registration'>
    <Button fluid onClick={onToggle} style={{ marginBottom: '10px' }}>
      {isExpanded ? '▲ Свернуть форму' : '▼ Развернуть форму'}
    </Button>
    <iframe
      title='registration'
      src={REGISTRATION_URL}
      width='100%'
      height={isExpanded ? '100vh' : '300px'}
      frameBorder='0'
      marginHeight='0'
      marginWidth='0'
      style={isExpanded ? { position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: 1000 } : {}}
    >
      Loading...
    </iframe>
    {isExpanded && (
      <Button
        primary
        onClick={onToggle}
        style={{ position: 'fixed', top: '10px', right: '10px', zIndex: 1001 }}
      >
        ✕ Свернуть
      </Button>
    )}
  </div>
);
